module.exports = __webpack_public_path__ + "assets/express-clinic.19a69182.png";